import React, { useState, useEffect } from "react";
import { validate } from "email-validator";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";

export const QuestionnaireNurseDetailsPage = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [selectedOption, setSelectedOption] = useState({ email: "", name: "" });
	const [emailWarning, setEmailWarning] = useState("");

	useEffect(() => {
		setSelectedOption("");
	}, [def]);

	useEffect(() => {
		if (currentResponse) {
			setSelectedOption(currentResponse.value);
		} else {
			const _selectedOption = { email: "", name: "" };
			if (def.answer) {
				_selectedOption.email = def.answer.email || _selectedOption.email;
				_selectedOption.name = def.answer.name || _selectedOption.name;
			}
			setSelectedOption(_selectedOption);

			// make sure we set the current response to avoid the warning message if we don't save anything
			const response = {};
			response.id = def.id;
			response.value = _selectedOption;

			onRespond(response);
		}
	}, [currentResponse, def, onRespond]);

	const onNameChange = (e) => {
		const value = e.target.value;
		const _selectedOption = { ...selectedOption };

		_selectedOption.name = value;
		setSelectedOption(_selectedOption);

		const response = {};
		response.id = def.id;
		response.value = _selectedOption;

		onRespond(response);
	};

	const onEmailChange = (e) => {
		const value = e.target.value;
		const _selectedOption = { ...selectedOption };

		let warning = "";
		if (value.length > 0) {
			warning = validate(value)
				? "Looks like a valid email"
				: "The email doesn't look valid";
		}
		setEmailWarning(warning);

		_selectedOption.email = value;
		setSelectedOption(_selectedOption);

		const response = {};
		response.id = def.id;
		response.value = _selectedOption;

		onRespond(response);
	};

	return (
		<>
			<QuestionnaireHeader def={def} />

			<div className={"w-full mx-auto px-6 mt-4"}>
				<div className={"mb-2 w-full text-sm"}>
					<label className={"block my-auto"} htmlFor={"nursename"}>
						Name
					</label>
					<div className="w-full">
						<input
							id="nursename"
							value={selectedOption.name}
							onChange={onNameChange}
							className="w-full mr-2 rounded-sm border border-black px-2 leading-7 w-10/12 max-w-full"
							autoComplete="off"
						/>
					</div>
				</div>
			</div>

			<div className={"w-full mx-auto px-6 mt-4"}>
				<div className={"mb-2 w-full text-sm"}>
					<label className={"block my-auto"} htmlFor={"nurseemail"}>
						Email
					</label>
					<div className="w-full">
						<input
							id="nurseemail"
							value={selectedOption.email}
							onChange={onEmailChange}
							className="w-full mr-2 rounded-sm border border-black px-2 leading-7 w-10/12 max-w-full"
							autoComplete="off"
						/>
					</div>
					<div className="w-full text-sm mt-1">{emailWarning}</div>
				</div>
			</div>

			<QuestionnaireFooter def={def} />
		</>
	);
};
